/**
 * RTK Query bridge — keeps network/cache in dashboardApi while repositories stay framework-agnostic.
 * See: data/interests/repositories/interest_repository_impl.ts
 */

import { store } from '@/app/store'
import { dashboardApi } from '@/data/dashboard/api/dashboard_api'
import type { CreateInterestPayload, UpdateInterestPayload } from '@/domain/interests/entities/interest.entity'

export class InterestsRtkDatasource {
  async list(page = 0, limit = 50) {
    const result = await store.dispatch(
      dashboardApi.endpoints.getInterests.initiate({ page, limit })
    )
    if (result.error) {
      throw result.error
    }
    return result.data ?? []
  }

  async getById(id: string) {
    const result = await store.dispatch(dashboardApi.endpoints.getInterestById.initiate(id))
    if (result.error) {
      throw result.error
    }
    if (!result.data) {
      throw new Error('Interest not found')
    }
    return result.data
  }

  async create(payload: CreateInterestPayload) {
    const result = await store.dispatch(
      dashboardApi.endpoints.createInterest.initiate(payload)
    )
    if (result.error) {
      throw result.error
    }
    if (!result.data) {
      throw new Error('Failed to create interest')
    }
    return result.data
  }

  async update(payload: UpdateInterestPayload) {
    const result = await store.dispatch(
      dashboardApi.endpoints.updateInterest.initiate(payload)
    )
    if (result.error) {
      throw result.error
    }
    if (!result.data) {
      throw new Error('Failed to update interest')
    }
    return result.data
  }

  async delete(id: string) {
    const result = await store.dispatch(dashboardApi.endpoints.deleteInterest.initiate(id))
    if (result.error) {
      throw result.error
    }
  }
}
